import React, { useEffect } from 'react';
import '../styles/term-of-service.css';
import { useSettings } from '../context/SettingsContext';

const TermOfServicePage = () => {
    const { termOfService } = useSettings();

    useEffect(() => {
        document.title = 'Iampesmobile - Điều khoản dịch vụ';
    }, []);

    return (
        <div className="tos-page-shell">
            <section className="tos-page-hero">
                <p className="tos-page-kicker">Legal & Policy</p>
                <h1 className="tos-page-title">Điều Khoản Dịch Vụ</h1>
                <p className="tos-page-subtitle">
                    Quy định sử dụng dịch vụ giúp bảo vệ quyền lợi của cả người dùng và hệ thống.
                </p>
            </section>

            <section className="tos-page-content">
                {termOfService.map((term, index) => (
                    <article key={term.id || index} className="tos-page-item">
                        <h2 className="tos-page-item-title">{term.title}</h2>
                        <p className="tos-page-item-content">{term.content}</p>
                    </article>
                ))}
            </section>
        </div>
    );
};

export default TermOfServicePage;
